export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20stylized%20comic%20illustration%20of%20a%20cozy%20reader%20holding%20a%20tablet%20reading%20manga%20at%20a%20wooden%20desk%2C%20soft%20amber%20and%20cream%20tones%2C%20speech%20bubbles%20floating%2C%20plants%20and%20lamp%20in%20background%2C%20playful%20editorial%20art%2C%20high%20detail%2C%20harmonious%20warm%20composition&width=1600&height=900&seq=comic-hero-2026&orientation=landscape"
        alt="在温暖光线下用平板阅读漫画的插画"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/25"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-50/95 via-transparent to-transparent"></div>

      <div className="relative mx-auto w-full max-w-6xl px-4 py-24 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-4 py-1.5 text-sm font-medium text-background-50">
            <i className="ri-flashlight-fill text-base"></i>
            漫画阅读技巧一站通
          </span>
          <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
            把漫画软件应用
            <br />
            用到得心应手
          </h1>
          <p className="mt-6 text-base leading-relaxed text-background-100 md:text-lg">
            从阅读模式、夜间模式到缓存下载、订阅提醒、分类检索与离线阅读，一份指南帮你轻松掌握主流漫画阅读软件的使用技巧，畅快追漫、不错过任何更新。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#reading"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              开始探索功能 <i className="ri-arrow-down-line"></i>
            </a>
            <a
              href="#faq"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50/95 px-6 py-3 text-sm font-medium text-foreground-900 transition hover:bg-background-100"
            >
              查看常见问题
            </a>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-background-100">
            <span className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-secondary-300"></i> 阅读模式详解
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-secondary-300"></i> 夜间模式设置
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-secondary-300"></i> 缓存与离线阅读
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}